import {Component, OnInit} from '@angular/core';
import {APP_VERSION} from '../../../version';

@Component({
  selector: 'ms-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})

export class HomeComponent implements OnInit{
  public version: string = APP_VERSION;

  constructor() {
  }

  ngOnInit() {
  }
}
